import { TeamResponse } from 'api';

import NameColumn from './NameColumn';
import LearnerCountColumn from './LearnerCountColumn';
import OrganisationColumn from './OrganisationColumn';

const columnPredicate = (
  columnName: keyof TeamResponse,
  columnValue: string | number,
  props: TeamResponse,
) => {
  const { id, name, visibility, learnerCount, migrated, location } = props;
  const organisationCount =
    props.organisationContext?.organisations?.length ?? 1;
  switch (columnName) {
    case 'name':
      return (
        <NameColumn
          organisationCount={organisationCount}
          id={id}
          name={name}
          visibility={visibility}
        ></NameColumn>
      );
    case 'learnerCount':
      return (
        <LearnerCountColumn
          learnerCount={learnerCount}
          migrated={migrated}
          location={location}
        ></LearnerCountColumn>
      );
    case 'organisationContext':
      return (
        <OrganisationColumn
          organisations={props.organisationContext?.organisations}
        ></OrganisationColumn>
      );
    default:
      return columnValue;
  }
};

export default columnPredicate;
